export default __webpack_public_path__ + "static/media/plus-in-circle.39f0fef7.svg";